import React, { useContext, useEffect, useState } from "react";
import { Alpha1Set, Alpha2Set, Rotate1Set, Rotate2Set } from "../App";

export const ButtonAlpha = () => {
  const { alpha1set, setAlpha1Set } = useContext(Alpha1Set);
  const { alpha2set, setAlpha2Set } = useContext(Alpha2Set);
  const { rotate1set, setRotate1Set } = useContext(Rotate1Set);
  const { rotate2set, setRotate2Set } = useContext(Rotate2Set);
  const alphaset = [0.01, 0.2, 0.4, 0.9, 1];
  const alphachara = ["線", "薄", "淡", "濃", "塗"];
  const [count, setCount] = useState(Number(4));

  const increment = () => {
    // setRotate1Set(false);
    // setRotate2Set(false);
    setCount((prevCount) => prevCount + 1);
  };
  const decrement = () => {
    setCount((prevCount) => prevCount - 1);
    // setRotate1Set(false);
    // setRotate2Set(false);
  };

  useEffect(() => {
    setAlpha1Set(alphaset[count]);
    setAlpha2Set(alphaset[count]);
  }, [count]);

  return (
    <>
      <div
        className="flex justify-center md:rounded-xl bg-gray-200 p-1 md:py-1"
        x-data="app"
      >
        <div className="px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base">
          {count >= 4 && (
            <div className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-200 text-white">
              +
            </div>
          )}
          {count < 4 && (
            <div
              onClick={increment}
              className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-500 text-white"
            >
              +
            </div>
          )}
          <div className="md:my-2 text-sm md:text-base lg:text-xl">
            <h1>{alphachara[count]}</h1>
          </div>
          {count > 0 && (
            <div
              onClick={decrement}
              className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-500 text-white"
            >
              -
            </div>
          )}
          {count <= 0 && (
            <div className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-200 text-white">
              -
            </div>
          )}
        </div>
      </div>
    </>
  );
};
